export default __webpack_public_path__ + "images/0xde12c7959e1a72bbe8a5f7a1dc8f8eef9ab011b3.png";